"use client";

import { useLayoutEffect } from "react";
import { useAppContext } from "~/contexts/AppContext";
import { useCourseContext } from "~/contexts/CourseContext";
import { useCustomThemeContext } from "~/contexts/CustomThemeContext";

export const CourseLayout = ({ children }: { children: React.ReactNode }) => {
  const { headerHeight } = useAppContext();
  const { course } = useCourseContext();
  const { setCourseCss, clearCourseCss } = useCustomThemeContext();

  // useLayoutEffect fires synchronously before the browser paints, so the
  // correct CSS is in place on the very first visible frame.
  //
  // We call setCourseCss with:
  //   course.css (string) → course has CSS, use it (suppresses custom theme)
  //   null                → course has no CSS, fall back to custom theme
  //
  // On unmount (leaving course page) clearCourseCss() resets to null so the
  // custom theme can apply on non-course pages again.
  useLayoutEffect(() => {
    setCourseCss(course?.css ?? null);
    return () => clearCourseCss();
  }, [course?.css, setCourseCss, clearCourseCss]);

  return (
    <div style={{ marginTop: headerHeight }}>
      {children}
    </div>
  );
};
